export const trackFbEvents = (event) => {
  if (!window.fbq) return;
  if (process.env.REACT_APP_NODE_ENV === 'prod') window.fbq('trackCustom', event, { source: 'React' });
};
